import { graphql } from 'src/graphql';

export const TokenLimitCheck = graphql(`
  query TokenLimitCheck {
    tokenLimitCheck {
      daily {
        allowed
        tokensUsed
        tokensRemaining
        windowResetTime
      }
    }
  }
`);
